
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: 'OffersPage',
}) 
export default class OffersPage extends Vue {
}
